(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brx-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarBRX extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('data-initialized')) {
        this.setAttribute('data-initialized', 'true');
        this.init();
      }
    }

    init() {
      const slider = this.querySelector('.splide');
      const singleSlide = this.querySelector('.brx-announcement-bar__single');

      if (singleSlide) {
        // Handle single slide background
        this.updateSectionBackgroundFromElement(singleSlide);
        return;
      }

      if (!slider) return;

      const autoplay = slider.dataset.autoplay === 'true';
      const interval = parseInt(slider.dataset.interval) || 5000;
      const showArrows = slider.dataset.arrows === 'true';
      const animationType = slider.dataset.type || 'slide';

      // Force autoplay when arrows are hidden (unless there's only one slide)
      const slides = slider.querySelectorAll('.splide__slide');
      const forceAutoplay = !showArrows && slides.length > 1;

      const splideConfig = {
        type: animationType,
        rewind: animationType === 'fade' || animationType === 'slide',
        arrows: showArrows,
        pagination: false,
        autoplay: forceAutoplay || autoplay,
        interval: interval,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: 'global',
        accessibility: {
          slideRole: 'group',
          slideLabel: (index, total) => `${index + 1} of ${total} announcements`,
        }
      };

      // Disable autoplay if there's only one slide
      if (slides.length <= 1) {
        splideConfig.autoplay = false;
        splideConfig.arrows = false;
      }

      if (window.Splide) {
        const splideInstance = new Splide(slider, splideConfig);

        // Store splide instance for later reference
        this.splideInstance = splideInstance;

        // Mount the splide instance
        splideInstance.mount();

        // Add event listeners to update section background when slide changes
        // Use 'move' event for immediate background change at start of transition
        splideInstance.on('move', (newIndex) => {
          this.updateSectionBackgroundFromSplideIndex(newIndex);
        });

        // Also listen to 'moved' as fallback and for initial setup
        splideInstance.on('moved', (newIndex) => {
          this.updateSectionBackgroundFromSplide();
        });

        // Set initial background based on first slide
        this.updateSectionBackgroundFromSplide();
      } else {
        // Fallback when Splide library is not loaded
        console.warn('Splide library is not loaded');
      }
    }

    updateSectionBackground(slideIndex) {
      const slider = this.querySelector('.splide');
      const animationType = slider?.dataset.type || 'slide';

      if (animationType === 'loop') {
        // For loop type, find the currently active slide (not clone)
        const activeSlide = this.querySelector('.splide__slide.is-active:not(.splide__slide--clone)');
        if (activeSlide) {
          this.updateSectionBackgroundFromElement(activeSlide);
          this.updateArrowColor(activeSlide);
          return;
        }
      }

      // Fallback for other animation types
      const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');

      // Ensure index is within bounds
      const actualIndex = Math.max(0, Math.min(slideIndex, slides.length - 1));

      if (slides[actualIndex]) {
        this.updateSectionBackgroundFromElement(slides[actualIndex]);
        this.updateArrowColor(slides[actualIndex]);
      }
    }

    updateSectionBackgroundFromSplide() {
      if (!this.splideInstance) return;

      const slider = this.querySelector('.splide');
      const animationType = slider?.dataset.type || 'slide';

      if (animationType === 'loop') {
        // For loop type, find the currently active slide (not clone)
        const activeSlide = this.querySelector('.splide__slide.is-active:not(.splide__slide--clone)');
        if (activeSlide) {
          this.updateSectionBackgroundFromElement(activeSlide);
          this.updateArrowColor(activeSlide);
          return;
        }
      }

      // Fallback for other animation types
      const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
      const currentIndex = this.splideInstance.index;

      // Ensure index is within bounds
      const actualIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));

      if (slides[actualIndex]) {
        this.updateSectionBackgroundFromElement(slides[actualIndex]);
        this.updateArrowColor(slides[actualIndex]);
      }
    }

    updateSectionBackgroundFromSplideIndex(newIndex) {
      // This method is called during 'move' event with the target index
      const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');

      // Ensure index is within bounds
      const actualIndex = Math.max(0, Math.min(newIndex, slides.length - 1));

      if (slides[actualIndex]) {
        this.updateSectionBackgroundFromElement(slides[actualIndex]);
        this.updateArrowColor(slides[actualIndex]);
      }
    }

    updateSectionBackgroundFromElement(element) {
      const blockBgColor = element.dataset.blockBgColor;

      if (blockBgColor && blockBgColor.trim() !== '') {
        this.style.backgroundColor = blockBgColor;
      } else {
        this.style.backgroundColor = '';
      }
    }

    updateArrowColor(element) {
      const slider = this.querySelector('.splide');
      if (!slider) return;

      const blockTextColor = getComputedStyle(element).getPropertyValue('--block-text-color').trim();

      if (blockTextColor && blockTextColor !== '') {
        slider.style.setProperty('--arrow-color', blockTextColor);
      } else {
        slider.style.removeProperty('--arrow-color');
      }
    }
  }

  // Define custom element
  if (!customElements.get('brx-announcement-bar')) {
    customElements.define('brx-announcement-bar', AnnouncementBarBRX);
  }

  // Initialize existing elements on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    const announcementBars = document.querySelectorAll('brx-announcement-bar');
    announcementBars.forEach(bar => {
      if (!bar.hasAttribute('data-initialized') && bar instanceof HTMLElement) {
        // Force initialize elements that haven't been initialized yet
        customElements.upgrade(bar);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brx-featured-blog"] && !Shopify.designMode) return;
  try {
    
  class BRXFeaturedBlog extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('data-initialized')) {
        this.setAttribute('data-initialized', 'true');
        this.init();
      }
    }

    init() {
      const slider = this.querySelector('.brx-blog-slider');
      if (!slider) return;

      // Wait for Splide library to be loaded
      if (typeof Splide === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      this.initializeSlider(slider);
    }

    initializeSlider(slider) {
      if (!window.Splide) return;

      const perPageMobile = parseInt(slider.dataset.perPageMobile) || 1;
      const paddingMobile = parseFloat(slider.dataset.paddingMobile) || 0;
      const gap = parseInt(slider.dataset.gap) || 16;
      const paginationType = slider.dataset.pagination || 'none';
      const paginationPosition = slider.dataset.paginationPosition || 'inside';

      const mobilePadding = paddingMobile > 0 ? `${paddingMobile}px` : '0px';

      const slides = slider.querySelectorAll('.splide__slide');

      // Destroy existing instance if it exists
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }

      const splideConfig = {
        type: 'slide',
        rewind: true,
        arrows: false,
        pagination: false, // Disable default pagination to use custom pagination
        autoplay: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: 'global',
        autoHeight: true,
        perPage: perPageMobile,
        perMove: 1,
        gap: gap,
        padding: mobilePadding,
        breakpoints: {
          989: {
            perPage: perPageMobile,
            padding: mobilePadding,
            gap: gap,
          }
        },
        accessibility: {
          slideRole: 'group',
          slideLabel: (index, total) => `${index + 1} of ${total} slides`,
        }
      };      // Disable autoplay and arrows if there's only one slide
      if (slides.length <= 1) {
        splideConfig.autoplay = false;
        splideConfig.arrows = false;
        splideConfig.pagination = false;
      }

      const splideInstance = new Splide(slider, splideConfig);

      // Store splide instance for later reference
      this.splideInstance = splideInstance;

      // Custom pagination setup
      if (paginationType !== 'none' && slides.length > 1) {
        this.setupCustomPagination(splideInstance, paginationType, paginationPosition);
      }

      // Mount the splide instance
      splideInstance.mount();

      // After mounting, ensure pagination is visible (override Splide's default hiding)
      if (paginationType !== 'none' && slides.length > 1) {
        setTimeout(() => {
          const paginationElements = this.querySelectorAll('.brx-blog-pagination');
          paginationElements.forEach(pagination => {
            pagination.style.display = 'flex';
          });
        }, 0);
      }
    }

    setupCustomPagination(splideInstance, type, position) {
      // Find the pagination container (inside or outside the slideshow)
      let paginationContainer = this.querySelector('.c-slider-pagination--outside-center');
      if (!paginationContainer) {
        paginationContainer = this.querySelector('.c-slider-pagination');
      }

      if (!paginationContainer) return;

      // Force display the pagination (Splide hides it by default)
      paginationContainer.style.display = 'flex';

      // Apply CSS variables if this is an outside-center pagination
      if (paginationContainer.classList.contains('c-slider-pagination--outside-center')) {
        const slider = this.querySelector('.splide');
        if (slider) {
          // Copy CSS variables from slider to outside pagination
          const sliderStyle = getComputedStyle(slider);
          const cssVars = [
            '--pagination-dots-background',
            '--pagination-dots-border',
            '--pagination-dots-active-background',
            '--pagination-dots-spacing',
            '--pagination-dots-size',
            '--pagination-numbers-text',
            '--pagination-numbers-background',
            '--pagination-numbers-border',
            '--pagination-numbers-active-text',
            '--pagination-numbers-active-background',
            '--pagination-numbers-spacing',
            '--pagination-numbers-font-size',
            '--pagination-fraction-text',
            '--pagination-fraction-border',
            '--pagination-fraction-background',
            '--pagination-fraction-font-size'
          ];

          cssVars.forEach(varName => {
            const value = sliderStyle.getPropertyValue(varName);
            if (value) {
              paginationContainer.style.setProperty(varName, value);
            }
          });
        }
      }

      // Clear existing content
      paginationContainer.innerHTML = '';

      // Add class for styling
      if (type === 'numbers') {
        paginationContainer.classList.add('c-slider-pagination--numbers');
      } else if (type === 'fraction') {
        paginationContainer.classList.add('c-slider-pagination--fraction');
      }

      // Create pagination items
      const slides = this.querySelectorAll('.splide__slide');

      if (type === 'fraction') {
        // Create fraction display (e.g., "1 / 5")
        const listItem = document.createElement('li');
        const fractionDisplay = document.createElement('span');
        fractionDisplay.className = 'c-slider-pagination__fraction';
        fractionDisplay.textContent = `1 / ${slides.length}`;

        listItem.appendChild(fractionDisplay);
        paginationContainer.appendChild(listItem);

        // Update fraction on slide change
        splideInstance.on('move', (newIndex) => {
          fractionDisplay.textContent = `${newIndex + 1} / ${slides.length}`;
        });
      } else {
        // Create button pagination (dots or numbers)
        slides.forEach((slide, index) => {
          // Create li element for proper HTML structure
          const listItem = document.createElement('li');

          // Create button element
          const button = document.createElement('button');
          button.className = 'c-slider-pagination__page';
          button.type = 'button';
          button.setAttribute('aria-label', `Go to slide ${index + 1}`);

          if (type === 'numbers') {
            button.textContent = index + 1;
          }

          if (index === 0) {
            button.classList.add('is-active');
          }

          // Add click event listener
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (splideInstance && typeof splideInstance.go === 'function') {
              splideInstance.go(index);
            }
          });

          // Append button to li, then li to pagination container
          listItem.appendChild(button);
          paginationContainer.appendChild(listItem);
        });

        // Update active state on slide change start (immediate response)
        splideInstance.on('move', (newIndex) => {
          const buttons = paginationContainer.querySelectorAll('.c-slider-pagination__page');
          buttons.forEach((button, index) => {
            button.classList.toggle('is-active', index === newIndex);
          });
        });
      }
    }

    disconnectedCallback() {
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }
    }
  }

  // Define custom element
  if (!customElements.get('brx-featured-blog')) {
    customElements.define('brx-featured-blog', BRXFeaturedBlog);
  }

  // Initialize existing elements on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    const blogSections = document.querySelectorAll('brx-featured-blog');
    blogSections.forEach(blogSection => {
      if (!blogSection.hasAttribute('data-initialized') && blogSection instanceof HTMLElement) {
        // Force initialize elements that haven't been initialized yet
        customElements.upgrade(blogSection);
      }
    });
  });

  // Listen for theme editor changes
  document.addEventListener('shopify:section:load', function(event) {
    const blogSection = event.target.querySelector('brx-featured-blog');
    if (blogSection) {
      blogSection.removeAttribute('data-initialized');
      customElements.upgrade(blogSection);
    }
  });

  document.addEventListener('shopify:section:reorder', function(event) {
    const blogSection = event.target.querySelector('brx-featured-blog');
    if (blogSection) {
      blogSection.removeAttribute('data-initialized');
      customElements.upgrade(blogSection);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brx-password-teaser"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Countdown timer
    var countdown = document.querySelector('[data-countdown-date]');
    if (!countdown) return;

    var targetDate = new Date(countdown.getAttribute('data-countdown-date')).getTime();
    var expiredMessage = countdown.getAttribute('data-countdown-expired');
    var daysEl = countdown.querySelector('[data-days]');
    var hoursEl = countdown.querySelector('[data-hours]');
    var minutesEl = countdown.querySelector('[data-minutes]');
    var secondsEl = countdown.querySelector('[data-seconds]');

    function updateCountdown() {
      var now = new Date().getTime();
      var distance = targetDate - now;

      if (distance < 0) {
        countdown.innerHTML = '<p class="countdown__expired">' + expiredMessage + '</p>';
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = days;
      if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
      if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
      if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brx-slideshow-mv"] && !Shopify.designMode) return;
  try {
    
  class SlideshowBRX extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('data-initialized')) {
        this.setAttribute('data-initialized', 'true');
        this.init();
      }
    }

    init() {
      const slider = this.querySelector('.splide');
      const singleSlide = this.querySelector('.brx-slideshow-mv__single');

      if (singleSlide) {
        // Single slide, no need for slider functionality
        return;
      }

      if (!slider) return;

      // Constants
      const MIN_MOBILE_GAP = 10; // Minimum gap value for mobile to maintain readability

      const autoplay = slider.dataset.autoplay === 'true';
      const interval = parseInt(slider.dataset.interval) || 5000;
      const speed = parseInt(slider.dataset.speed) || 600;
      const showArrows = slider.dataset.arrows === 'true';
      const paginationType = slider.dataset.pagination || 'none';
      const paginationPosition = slider.dataset.paginationPosition || 'center';
      const animationType = slider.dataset.type || 'slide';
      const perPageDesktop = parseInt(slider.dataset.perPageDesktop) || 1;
      const perPageMobile = parseInt(slider.dataset.perPageMobile) || 1;
      const paddingDesktop = parseFloat(slider.dataset.paddingDesktop) || 0;
      const paddingMobile = parseFloat(slider.dataset.paddingMobile) || 0;
      const gap = parseInt(slider.dataset.gap) || 20;

      // Use padding values directly from settings
      const desktopPadding = paddingDesktop > 0 ? `${paddingDesktop}%` : 0;
      const mobilePadding = paddingMobile > 0 ? `${paddingMobile}%` : 0;

      const slides = slider.querySelectorAll('.splide__slide');
      // Use autoplay setting from section configuration
      const shouldAutoplay = autoplay && slides.length > 1;

      const splideConfig = {
        type: animationType,
        rewind: animationType === 'fade' || animationType === 'slide',
        arrows: showArrows,
        pagination: false, // Disable default pagination to use custom pagination
        autoplay: shouldAutoplay,
        interval: interval,
        speed: speed,
        pauseOnHover: true,
        pauseOnFocus: true,
        keyboard: 'global',
        autoHeight: true,
        perPage: perPageDesktop,
        perMove: 1,
        gap: gap,
        padding: desktopPadding,
        breakpoints: {
          989: {
            perPage: perPageMobile,
            padding: mobilePadding,
            gap: Math.max(gap / 2, MIN_MOBILE_GAP), // Mobile gap is smaller but maintains minimum for readability
          }
        },
        accessibility: {
          slideRole: 'group',
          slideLabel: (index, total) => `${index + 1} of ${total} slides`,
        }
      };

      // Disable autoplay and arrows if there's only one slide
      if (slides.length <= 1) {
        splideConfig.autoplay = false;
        splideConfig.arrows = false;
        splideConfig.pagination = false;
      }

      if (window.Splide) {
        const splideInstance = new Splide(slider, splideConfig);

        // Store splide instance for later reference
        this.splideInstance = splideInstance;

        // Mount the splide instance first, then setup custom pagination
        // (Splide's mount sets display:none on placeholder when pagination:false)
        splideInstance.mount();

        // Custom pagination setup (after mount to override Splide's display:none)
        if (paginationType !== 'none' && slides.length > 1) {
          this.setupCustomPagination(splideInstance, paginationType, paginationPosition);
        }
      } else {
        // Fallback when Splide library is not loaded
        console.warn('Splide library is not loaded');
      }
    }

    setupCustomPagination(splideInstance, type, position) {
      // Find the pagination container based on position setting
      let paginationContainer;
      if (position === 'outside-center') {
        paginationContainer = this.querySelector('.c-slider-pagination--outside-center');
      } else {
        paginationContainer = this.querySelector(`.c-slider-pagination--${position}`) ||
          this.querySelector('.c-slider-pagination:not(.c-slider-pagination--outside-center)');
      }

      if (!paginationContainer) return;

      // Force display the pagination (Splide hides it by default)
      paginationContainer.style.display = 'flex';

      // Apply CSS variables if this is an outside-center pagination
      if (paginationContainer.classList.contains('c-slider-pagination--outside-center')) {
        const slider = this.querySelector('.splide');
        if (slider) {
          // Copy CSS variables from slider to outside pagination
          const sliderStyle = getComputedStyle(slider);
          const cssVars = [
            '--pagination-dots-background',
            '--pagination-dots-border',
            '--pagination-dots-active-background',
            '--pagination-dots-spacing',
            '--pagination-dots-size',
            '--pagination-numbers-text',
            '--pagination-numbers-background',
            '--pagination-numbers-border',
            '--pagination-numbers-active-text',
            '--pagination-numbers-active-background',
            '--pagination-numbers-spacing',
            '--pagination-numbers-font-size',
            '--pagination-fraction-text',
            '--pagination-fraction-border',
            '--pagination-fraction-background',
            '--pagination-fraction-font-size'
          ];

          cssVars.forEach(varName => {
            const value = sliderStyle.getPropertyValue(varName);
            if (value) {
              paginationContainer.style.setProperty(varName, value);
            }
          });
        }
      }

      // Clear existing content
      paginationContainer.innerHTML = '';

      // Add class for styling
      if (type === 'numbers') {
        paginationContainer.classList.add('c-slider-pagination--numbers');
      } else if (type === 'fraction') {
        paginationContainer.classList.add('c-slider-pagination--fraction');
      }

      // Create pagination items
      // Exclude Splide's cloned slides (generated when type: 'loop') to avoid duplicated pagination buttons
      const slides = this.querySelectorAll('.splide__slide:not(.splide__slide--clone)');

      if (type === 'fraction') {
        // Create fraction display (e.g., "1 / 5")
        const listItem = document.createElement('li');
        const fractionDisplay = document.createElement('span');
        fractionDisplay.className = 'c-slider-pagination__fraction';
        fractionDisplay.textContent = `1 / ${slides.length}`;

        listItem.appendChild(fractionDisplay);
        paginationContainer.appendChild(listItem);

        // Update fraction on slide change
        splideInstance.on('move', (newIndex) => {
          fractionDisplay.textContent = `${newIndex + 1} / ${slides.length}`;
        });
      } else {
        // Create button pagination (dots or numbers)
        slides.forEach((slide, index) => {
          // Create li element for proper HTML structure
          const listItem = document.createElement('li');

          // Create button element
          const button = document.createElement('button');
          button.className = 'c-slider-pagination__page';
          button.type = 'button';
          button.setAttribute('aria-label', `Go to slide ${index + 1}`);

          if (type === 'numbers') {
            button.textContent = index + 1;
          }

          if (index === 0) {
            button.classList.add('is-active');
          }

          // Add click event listener
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (splideInstance && typeof splideInstance.go === 'function') {
              splideInstance.go(index);
            }
          });

          // Append button to li, then li to pagination container
          listItem.appendChild(button);
          paginationContainer.appendChild(listItem);
        });

        // Update active state on slide change start (immediate response)
        splideInstance.on('move', (newIndex) => {
          const buttons = paginationContainer.querySelectorAll('.c-slider-pagination__page');
          buttons.forEach((button, index) => {
            button.classList.toggle('is-active', index === newIndex);
          });
        });
      }
    }
  }

  // Define custom element
  if (!customElements.get('brx-slideshow-mv')) {
    customElements.define('brx-slideshow-mv', SlideshowBRX);
  }

  // Initialize existing elements on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    const slideshows = document.querySelectorAll('brx-slideshow-mv');
    slideshows.forEach(slideshow => {
      if (!slideshow.hasAttribute('data-initialized') && slideshow instanceof HTMLElement) {
        // Force initialize elements that haven't been initialized yet
        customElements.upgrade(slideshow);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password-header"]) return;
  try {
    
  (function() {
    var ALLOWED_KEY = 'access';
    var ALLOWED_VALUE = 'dev';

    function checkAccess() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(ALLOWED_KEY) === ALLOWED_VALUE;
    }

    function initPasswordModal() {
      var modal = document.querySelector('password-modal[data-access-control="restricted"]');

      if (!modal) return;

      if (checkAccess()) {
        modal.style.display = '';
      } else {
        modal.remove();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPasswordModal);
    } else {
      initPasswordModal();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
